import React, { useState, useEffect, useRef } from 'react';
import { Splide, SplideSlide } from '@splidejs/react-splide';
import {iOS } from '../utils/apiUtils';
import { axios, getAxiosConfig } from '../utils/apiUtils';
import styles from './Landing.module.css';
import logo from '../assets/images/logo_sin_hagamos_cosas_juntos.png';
import colibriThumbnail from '../assets/images/COLIBRI_Poesía Canciones del Colibri .jpeg';
import monitoThumbnail from '../assets/images/MONITO DEL MONTE_Cuento con titeres.jpeg';
import condorThumbnail from '../assets/images/CONDOR_Manualidad.jpeg';
import { Stream } from '@cloudflare/stream-react';
import { useGTMDispatch } from '@elgorditosalsero/react-gtm-hook';
import { reportEvent } from '../utils/analyticsUtils';
import { getLoggedInUser } from '../utils/authUtils';
import { Button } from 'react-bootstrap';
import { Redirect } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import ReactPlayer from 'react-player';
import myVideo from '../assets/videos/VideoLandingChungungoV1.mp4';
import cardIMG1 from '../assets/images/1.png';
import cardIMG2 from '../assets/images/2.png';
import cardIMG3 from '../assets/images/3.png';
import fbLogo from '../assets/images/fb.svg';
import igLogo from '../assets/images/ig.svg';
import unicefLogo from '../assets/images/mini-logo-unicef-blanco.png';

function debounce(fn, ms) {
  let timer
  return _ => {
    clearTimeout(timer)
    timer = setTimeout(_ => {
      timer = null
      fn.apply(this, arguments)
    }, ms)
  };
}

const Landing = () => {

  const { t, i18n } = useTranslation();
  const [isCompressed, setIsCompressed] = useState();
  const [goToSeasons, setGoToSeasons] = useState();
  const sendDataToGTM = useGTMDispatch();
  const video1 = useRef(null);
  const video2 = useRef(null);
  const video3 = useRef(null);

  useEffect(() => {
    sendDataToGTM({event: '01Funnel_LandingPage', value: ''})
    reportEvent('01Funnel_LandingPage', {});

    const debouncedHandleResize = debounce(function handleResize() {
      if (window.scrollY > 20) {
        setIsCompressed(true);
      }else {
        setIsCompressed(false);
      }
    }, 100)

    window.addEventListener('scroll', debouncedHandleResize)

    return _ => {
      window.removeEventListener('scroll', debouncedHandleResize)
    }
  });

  const registerExpressLoginEvent = () => {
    axios.post(
      `${process.env.REACT_APP_API_URL}/auth/express_login`,
      {},
      getAxiosConfig(),
    )
      .then(() => console.log('Express login...'))
      .catch(() => console.error('Failed express login event registering!'));
      setGoToSeasons(true);
  }

  if (goToSeasons) {
    return (<Redirect to="/seasons" />);
  }

  return (
    <div className={`${styles.landingHTML} ${styles.bodyLanding}`}>

      <header className={`fixed-top ${styles.navbarChungungo}`}>
        <nav className={`navbar navbar-expand navbar-light bg-light ${styles.navChungungo} ${isCompressed ? styles.navbarCompressed : ''}`} aria-label="Eighth navbar example">
          <div className={`container d-flex flex-column flex-lg-row ${styles.navContainer}`}>
            <a className="navbar-brand" href="/">
              <img style={{width: '100%'}} src={logo} alt="Chungungo" />
            </a>
            <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarChungungo"
              aria-controls="navbarChungungo" aria-expanded="false" aria-label="Toggle navigation">
              <span className="navbar-toggler-icon"></span>
            </button>

            <div className={`collapse navbar-collapse`}>
              <ul className="navbar-nav ml-lg-auto">
                <li className={`nav-item ${styles.loginBtn}`}>
                  {getLoggedInUser() &&
                    <Button variant='invisible' className={`nav-link ${styles.loginButton}`} onClick={() => registerExpressLoginEvent()}>Entrar</Button>
                  }
                  {!getLoggedInUser() &&
                    <a className={`nav-link ${styles.loginButton}`} href="/login">Entrar</a>
                  }
                </li>
                <li className="nav-item">
                  <a className={`nav-link btn btn-primary fw-bold ml-3 ${styles.registerBtn} ${styles.orangeBtn}`} href="/register">Crea tu cuenta</a>
                </li>
              </ul>
            </div>
          </div>
        </nav>
      </header>

      <section>
        <div className={`${styles.bgVideo} container-fluid`}>
          <ReactPlayer
            url={myVideo}
            playing={true}
            loop={true}
            width="100%"
            height="100%"
            style={{position:'absolute'}}
            muted
          />
          <div className={`${styles.m0}row d-flex align-items-center h-100`}>
            <div className={`${styles.colVideo} col-md-6 mx-auto`}>
              <div className={`${styles.textos} text-center`}>
                <span className={`${styles.tag}`}>Experiencias</span>
                <h1 className="mb-4">+Juego +Creatividad +Vínculo</h1>
                <p className="lead" style={{fontSize: '1.5rem'}}>Contenidos para jugar, aprender y crecer, juntos. Dirigida a educadoras y familias de niños de 2 a 6 años.</p>
                <a href="/register" className={`${styles.orangeBtn} ${styles.orangeBtnTitle} btn btn-primary text-light`}>Crea tu cuenta</a>
              </div>
            </div>
          </div>
        </div>
      </section>

      <main className={`${styles.principal} container-fluid`}>

        <div className="row">
          <div className={`col-lg-10 mx-auto ${styles.manifiesto} text-center mb-5`}>
            <h3 
              style= {{
                fontFamily: '"Roboto Mono","Liberation Mono","Courier New", monospace,',
                color: '#D14E00',
                fontWeight: 700,
                lineHeight: 1.2,
              }}
            >Queremos que niños y niñas, junto a sus padres, madres o</h3>
            <h3
              style= {{
                fontFamily: '"Roboto Mono","Liberation Mono","Courier New", monospace,',
                color: '#D14E00',
                fontWeight: 700,
                lineHeight: 1.2,
              }}>educadoras, creen y generen vínculos, jugando.</h3>
          </div>
          
        </div>

        <div
          className="row"
          style={{
            fontFamily: '"Roboto","Helvetica Neue",Arial,"Noto Sans",sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol","Noto Color Emoji"',
            fontSize: '1rem',
            fontWeight: 400,
            lineHeight: 1.5,
            color: '#212529',
          }}
        >
          <div className="col-lg-10 mx-auto text-center text-md-left">

            <div className={`${styles.principalViaje} ${styles.principalViajePaso1} row flex-row-reverse d-flex align-items-center`}>
              <div className={`col-12 col-md-6 video-container ${styles.videoContainer}`}>
                <Stream
                  streamRef={video1}
                  src="3f9bf7f4b87ab2ed79854d3c649958bb"
                  style={styles.videoPlayer}
                  autoplay={false}
                  controls={true}
                  responsive={true}
                  fluid={true}
                  aspectRatio="16:9"
                  poster={window.location.origin + colibriThumbnail}
                  onLoadStart={() => {video1.current.pause()}}
                />
              </div>
              <div className="col-12 col-md-6 px-5 py-4 py-md-0">
                <p>En Chungungo tenemos un catálogo de video-experiencias cuyo propósito es invitarte a jugar, crear, aprender junto a niños y niñas de entre 2 y 6 años en el mundo físico. Puedes verlas cuándo quieras y desde dónde quieras.</p>
              </div>
            </div>

            <div className={`${styles.principalViaje} ${styles.principalViajePaso2} row d-flex align-items-center`}>
              <div className={`col-12 col-md-6 video-container ${styles.videoContainer}`}>
                <Stream
                  streamRef={video2}
                  src="c67bda1858fa9b506f696d715b08182b"
                  style={styles.videoPlayer} 
                  autoplay={false}
                  controls={true}
                  responsive={true}
                  fluid={true}
                  aspectRatio="16:9"
                  poster={window.location.origin + condorThumbnail}
                  onLoadStart={() => {video2.current.pause()}}
                />
              </div>
              <div className="col-12 col-md-6 px-5 py-4 py-md-0">
                <p>Experiencias educativas, simples y relevantes, basadas en la flora, fauna y en nuestra identidad. Porque creemos en la importancia de acercarlas y acercarlos desde muy pequeños a la naturaleza; observándola, conociéndola, para cuidarla y valorarla.</p>
                <p>Chungungo es creatividad y simpleza.</p>
                <p>Chungungo es juego libre.</p>
                <p>Chungungo es generar vínculos de manera entretenida.</p>
              </div>
            </div>

            <div className={`${styles.principalViaje} row flex-row-reverse d-flex align-items-center`}>
              <div className={`col-12 col-md-6 video-container ${styles.videoContainer}`}>
                <Stream
                  streamRef={video3}
                  src="6ce5ab5c36bb174424a64a4d2a59c3be"
                  style={styles.videoPlayer} 
                  autoplay={false}
                  controls={true}
                  responsive={true}
                  fluid={true}
                  aspectRatio="16:9"
                  poster={window.location.origin + monitoThumbnail}
                  onLoadStart={() => {video3.current.pause()}}
                />
              </div>
              <div className="col-12 col-md-6 px-5 py-4 py-md-0">
                <p>Solo necesitas las ganas.</p>
                <p>Queremos que tengas siempre a mano posibilidades de actividades diseñadas para la primera infancia, inspiración e ideas para jugar y aprender junto a los niños y niñas.</p>
                <p>Diviértete, explora y déjate encantar por la simpleza de Chungungo.</p>
              </div>
            </div>
          </div>
        </div>
      </main>

      <section
        className={styles.ctaHome}
        style={{
          fontFamily: '"Roboto","Helvetica Neue",Arial,"Noto Sans",sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol","Noto Color Emoji"',
          fontSize: '1rem',
          fontWeight: 400,
          lineHeight: 1.5,
          color: '#212529',
        }}
      >
        <div className={`container`}>
          <div className="row">
            <div className="col text-center">
              <h3>No queremos niños y niñas pegados en las pantallas.</h3>
              <h2 className="mb-5">Queremos usar las pantallas para jugar, crear y aprender, juntos.</h2>
              <ul className="list-inline">
                <li className="list-inline-item">
                  <h6 className="m-0">{t('landing.price')}</h6>
                </li>
                <li className="list-inline-item"><a href="/register" className={`btn btn-primary ${styles.orangeBtn}`}>Crea tu cuenta</a></li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      <section className="container-fluid">
        <div className="row">
          <div className="col-lg-10 mx-auto">
            <div className="row row-flex">
              <div className="col-md-4 mb-4 mb-md-0">
                <div className={`${styles.card}`}>
                  <img src={cardIMG1} className="img-fluid" alt="" />
                  <div className={`${styles.cardContent} text-center`}>
                    <h3>¿Qué encontrarás en Chungungo?</h3>
                    <p>Una gran cantidad de video-experiencias, en permanente actualización. Desde cuentos, canciones y poesías, hasta manualidades, juegos y talleres. </p>
                  </div>
                </div>
              </div>
              <div className="col-md-4 mb-4 mb-md-0">
                <div className={`${styles.card}`}>
                  <img src={cardIMG2} className="img-fluid" alt="" />
                  <div className={`${styles.cardContent} text-center`}>
                    <h3>Vívelo a tu ritmo</h3>
                    <p>Chungungo es una plataforma ondemand. Tu decides cuándo, cuánto y dónde. Revisa nuestro contenido de apoyo para acompañarte en la experiencia.  </p>
                  </div>
                </div>
              </div>
              <div className="col-md-4 mb-4 mb-md-0">
                <div className={`${styles.card}`}>
                  <img src={cardIMG3} className="img-fluid" alt="" />
                  <div className={`${styles.cardContent} text-center`}>
                    <h3>Todo parte por una historia</h3>
                    <p>El viaje del Chungungo parte por un cuento y a partir de sus personajes e imaginario, se proponen distintas experiencias. Nada es al azar, todo tiene un propósito. </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <footer className={`${styles.footerLanding}`}>
        <div className="container">
          <div className="row">
            <div className="col-12 text-center">
              <ul className="nav justify-content-center">
                <li className="nav-item">
                  <a className="nav-link" href="/terms_and_conditions">Términos y Condiciones</a>
                </li>
                <li className="nav-item">
                  <a className="nav-link" href="/about">Acerca de</a>
                </li>
                <li className="nav-item">
                  <a className="nav-link" href="/faq">Preguntas Frecuentes</a>
                </li>
                <li className="nav-item">
                  <a className="nav-link" href="https://regala.chungungo.com/" target="_blank" rel="noreferrer">¿Quieres regalar Chungungo?</a>
                </li>
              </ul>
              <ul className="nav justify-content-center mb-5">
                <li className="nav-item">
                  <a className="nav-link" href="https://www.facebook.com/somoschungungo" target="_blank" rel="noreferrer"><img src={fbLogo} alt="Facebook" /></a>
                </li>
                <li className="nav-item">
                  <a className="nav-link" href="https://www.instagram.com/chungungo_com" target="_blank" rel="noreferrer"><img src={igLogo} alt="Instagram" /></a>
                </li>
              </ul>
              <small className="text-muted">Todos los derechos reservados© 2021 Chungungo SPA.</small>
            </div>
          </div>
        </div>
        <div className={`${styles.unicef}`}>
          <img src={unicefLogo} alt="Facebook" />
        </div>
      </footer>

    </div>
  );
}

export default Landing;